module.exports = __webpack_public_path__ + "static/media/sug-3.60f6807d.svg";